// ─── Zones de livraison (Dakar) ────────────────────────────────────────────
export const ZONES = [
  'Dakar',
  'Guédiawaye',
  'Pikine',
  'Rufisque',
  'Keur Massar',
  'Diamniadio',
  'Sebikotane',
  'Sangalkam',
  'Yenn',
  'Tivaoune peuhl',
  'Keur Ndiaye Lo',
  'Bargny',
  'Bambey',
  'Diourbel',
  'Mbacké',
  'Fatick',
  'Foundiougne',
  'Gossas',
  'Birkelane',
  'Kaffrine',
  'Koungheul',
  'Malem Hodar',
  'Guinguinéo',
  'Kaolack',
  'Nioro du Rip',
  'Kédougou',
  'Salemata',
  'Saraya',
  'Kolda',
  'Médina Yoro Foulah',
  'Vélingara',
  'Kébémer',
  'Linguère',
  'Louga',
  'Kanel',
  'Matam',
  'Ranérou-Ferlo',
  'Dagana',
  'Podor',
  'Saint-Louis',
  'Bakel',
  'Goudiry',
  'Tambacounda',
  'Mbour',
  'Thiès',
  'Tivaouane',
  'Bignona',
  'Oussouye',
  'Ziguinchor',
  'Sédhiou',
  'Bounkiling',
  'Goudomp',
  'Touba',
  'Autre',
];

export const LIVRAISON_TARIFS_FCFA = {
  Dakar: 2000,
  Pikine: 3000,
  Diourbel: 6000,
  Sebikotane: 7000,
  Diamniadio: 7000,
  'Keur Massar': 3500,
  Sangalkam: 7000,
  Yenn: 8000,
  Bargny: 5000,
  Kounoune: 6000,
  Keur_Ndiaye_lo: 6000,
  Tivaoune_peuhl: 5000,
  'Guédiawaye': 3000,
  Rufisque: 4500,
  Fatick: 6000,
  Kaffrine: 7000,
  Kaolack: 6800,
  Kedougou: 6000,
  Kolda: 9000,
  Louga: 6000,
  Matam: 6000,
  SaintLouis: 6000,
  Tambacounda: 6000,
  Thiès: 6000,
  Kedougou: 8800,
  Louga: 6600,
  Matam: 8800,
  Sédhiou: 7600,
  SaintLouis: 7000,
  Tambacounda: 7600,
  Thiès: 6000,
  Ziguinchor: 8000,
  Mbour: 6000,
  Touba:7000,
  Tivaouane:6000,
    'Guédiawaye': 3000,

  // Exemple:
  // Dakar: 2000,
};

// ─── Statuts des colis ──────────────────────────────────────────────────────
export const STATUTS = {
  entrepot_france: {
    label: 'Arrivé entrepôt (Paris)',
    color: '#0F766E',
    bg:    '#CCFBF1',
    dot:   '#0F766E',
    icon:  '�',
  },
  transit: {
    label: 'En transit',
    color: '#2563EB',
    bg:    '#DBEAFE',
    dot:   '#2563EB',
    icon:  '✈️',
  },
  entrepot_senegal: {
    label: 'Arrivé entrepôt (Sénégal)',
    color: '#166534',
    bg:    '#DCFCE7',
    dot:   '#166534',
    icon:  '🇸🇳',
  },
  dispatching: {
    label: 'Dispatching',
    color: '#7C3AED',
    bg:    '#EDE9FE',
    dot:   '#7C3AED',
    icon:  '🧩',
  },
  depot: {
    label: 'En dépôt',
    color: '#D97706',
    bg:    '#FEF3C7',
    dot:   '#D97706',
    icon:  '📦',
  },
  affecte: {
    label: 'Affecté à un livreur',
    color: '#0284C7',
    bg:    '#E0F2FE',
    dot:   '#0284C7',
    icon:  '✅',
  },
  en_route: {
    label: 'En route',
    color: '#059669',
    bg:    '#D1FAE5',
    dot:   '#059669',
    icon:  '🚚',
  },
  livre: {
    label: 'Livré',
    color: '#047857',
    bg:    '#D1FAE5',
    dot:   '#047857',
    icon:  '🎉',
  },
  echec: {
    label: 'Échec livraison',
    color: '#DC2626',
    bg:    '#FEE2E2',
    dot:   '#DC2626',
    icon:  '❌',
  },
};

// Ordre des statuts pour la timeline de suivi
export const STATUT_ORDER = ['entrepot_france', 'transit', 'entrepot_senegal', 'dispatching', 'depot', 'affecte', 'en_route', 'livre'];

export const STATUT_ORDER_INTERNATIONAL = ['entrepot_france', 'transit', 'entrepot_senegal', 'dispatching', 'affecte', 'en_route', 'livre'];

export const STATUT_ORDER_LOCAL = ['depot', 'affecte', 'en_route', 'livre'];

// ─── Modes de paiement ──────────────────────────────────────────────────────
export const PAIEMENTS = {
  wave:         { label: 'Wave',         icon: '💙' },
  orange_money: { label: 'Orange Money', icon: '🟠' },
  free_money:   { label: 'Free Money',   icon: '🟢' },
  cash:         { label: 'Espèces',      icon: '💵' },
};

// ─── Couleurs de la marque ──────────────────────────────────────────────────
export const BRAND = {
  primary:   '#4F46E5',
  secondary: '#8B5CF6',
  gradient:  'linear-gradient(135deg, #4F46E5 0%, #8B5CF6 100%)',
  dark:      '#1e1b4b',
};
